var $ = require("jquery");

$(document).ready(() => {
  const pseudoHover = [".card-horizontal", ".card"];

  $(pseudoHover.join(",")).hover(function() {
    if ($(this).hasClass("card--education")) return;
    if ($(this).hasClass("card--location")) return;
    if ($(this).find('[class$="__buttons"]').length > 0) return;

    $(this)
      .find(".button")
      .toggleClass("button--hover");
  });
});
